import { render } from "./RecursiveTable.vue?vue&type=template&id=0a83f4d2"
import script from "./RecursiveTable.vue?vue&type=script&lang=js"
export * from "./RecursiveTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__